export interface Settings {
    allow_forgot_password: boolean;
    captcha_public_site_key: string;
    is_in_update_password: boolean;
    is_in_verify_email: boolean;
    block_id: string;
    is_captcha_required: boolean;
    username_field_label: string;
    password_field_label: string;
    redirect_url: string;
    section_title: string;
    submit_button_label: string;
    instructions?: string;
    failed_login_message?: string;
}

export const defaultSettings: Settings = {
    allow_forgot_password: true,
    captcha_public_site_key: '',
    is_in_update_password: false,
    is_in_verify_email: false,
    block_id: '',
    is_captcha_required: false,
    username_field_label: 'Username',
    password_field_label: 'Password',
    redirect_url: '',
    section_title: 'Login',
    submit_button_label: 'Login to site',
};
